import { provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Densidade compacta (src/theme-density.scss): o index.html liga a classe por padrão (inclusive no
// HTML pré-renderizado). A preferência salva pelo ThemeService (localStorage.densidade = 'padrao')
// é aplicada aqui, antes do bootstrap, para valer em qualquer rota — inclusive as que não renderizam
// o header e, portanto, nunca injetam o serviço (ex.: login). O SSR descarta <script> inline do body,
// por isso a lógica fica no main.ts e não no index.html.
try {
  if (localStorage.getItem('densidade') === 'padrao') {
    document.body.classList.remove('densidade-compacta');
  }
} catch {
  // localStorage indisponível (modo privado/bloqueado): mantém o padrão compacto
}

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [provideZoneChangeDetection(), ...appConfig.providers],
}).catch(err => console.error(err));
